module.exports = __webpack_public_path__ + "img/pen.6c3b5497.svg";